import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import FadeIn from "./FadeIn";

const SplitStorySection = ({
  title,
  image,
  imageAlt = "",
  imageLeft = true,
  children,
  showDonate = false,
  className = "",
}) => (
  <section className={`ku-section bg-white ${className}`}>
    <div className="ku-container">
      {title && (
        <FadeIn>
          <h2 className="ku-heading-lg mb-12 md:mb-16">{title}</h2>
        </FadeIn>
      )}
      <div
        className={`grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${
          imageLeft ? "" : "[&>*:first-child]:order-2 [&>*:last-child]:order-1"
        }`}
      >
        <FadeIn direction={imageLeft ? "left" : "right"}>
          <div className="relative">
            <div className="absolute -inset-4 bg-ku-lavender/15 rounded-ku-lg blur-2xl" aria-hidden />
            <img
              src={image}
              alt={imageAlt}
              className="relative w-full rounded-ku-lg shadow-elevated object-cover object-center aspect-[4/3]"
            />
          </div>
        </FadeIn>
        <FadeIn direction={imageLeft ? "right" : "left"} delay={0.1}>
          <div className="ku-prose space-y-6">{children}</div>
          {showDonate && (
            <Link to="/donate" className="ku-btn-primary mt-8 inline-flex">
              <Heart className="w-5 h-5" fill="currentColor" />
              DONATE
            </Link>
          )}
        </FadeIn>
      </div>
    </div>
  </section>
);

export default SplitStorySection;
